<template>
    <div>
        <accept-ean-agb :custom-ean="!hasEan" @acceptAgb="acceptAgb"></accept-ean-agb>
        <Toolbar>
            <!-- RIGHT -->
            <template v-slot:right>
                <HelpButton />
            </template>
        </Toolbar>
        <div v-if="agbAccepted && !success" class="card card-custom">
            <div class="card-header">
                <div class="card-title">
                    <h3 class="card-label">{{ __('general.article_creation') }}</h3>
                </div>
            </div>

            <div class="timeline timeline-5 card-body">
                <div class="timeline-items">
                    <!--        EAN SELECTION        -->
                    <div v-if="!queryEan" class="timeline-item">
                        <div class="timeline-media bg-light-primary">
                            <i class="fas fa-check"></i>
                        </div>
                        <div class="timeline-desc timeline-desc-light-primary">
                        <span class="d-block font-weight-bolder text-primary mb-2">
                            {{ __('product.ean_selection.article_associated_ean') }}
                        </span>
                            <div class="form-group mb-8">
                                <div class="radio-inline row mt-10">
                                    <label class="col-lg-6 radio radio-lg mb-8"
                                           :class="stepOneCompleted ? 'radio-disabled' : ''">
                                        <input :disabled="stepOneCompleted" type="radio" name="hasEan" :value="true"
                                               v-model="hasEan"/>
                                        <span></span>
                                        {{ __('product.ean_selection.articles_associated') }}
                                    </label>
                                    <label class="col-lg-6 radio radio-lg"
                                           :class="stepOneCompleted ? 'radio-disabled' : ''">
                                        <input @click="stepOneCompleted = true" :disabled="stepOneCompleted"
                                               type="radio" name="hasEan" :value="false" v-model="hasEan"/>
                                        <span></span>
                                        {{ __('product.ean_selection.articles_not_associated') }}
                                    </label>
                                </div>
                                <small class="form-text text-muted mb-10">{{
                                        __('product.ean_selection.no_ean_provided')
                                    }}</small>
                                <div v-if="hasEan === true">
                                    <CheckEan :first-check=true
                                               @useFoundArticle="setArticle"
                                               @useCustomEan="setArticleEan(articles[0], $event)">
                                    </CheckEan>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div v-if="stepOneCompleted || !hasEan">
                        <div v-if="!articleFound">
                            <!--            SELECT BRAND SECTION            -->
                            <div class="timeline-item">
                                <div class="timeline-media bg-light-primary">
                                    <i class="fa fa-tags"></i>
                                </div>
                                <div class="timeline-desc timeline-desc-light-primary">
                                <span class="d-block font-weight-bolder text-primary mb-2">
                                    {{ __('product.brand_section.title') }}
                                </span>
                                    <div class="form-group mb-8 row">
                                        <div class="col-lg-6">
                                            <label>{{ __('product.brand_section.search_and_select_brand') }}</label>
                                            <new-article-brand v-if="!brand.name" :user-brands-only="!hasEan" @selectBrand="selectBrand">
                                            </new-article-brand>
                                            <div v-else>
                                                <input class="form-control" type="text" v-model="brand.name" disabled>
                                                <small class="form-text">
                                                    <a href="javascript:;" class="text-muted" @click="resetBrand()">
                                                        <u>{{ __('product.brand_section.change_selection') }}</u>
                                                    </a>
                                                </small>
                                            </div>
                                            <small v-if="errors[`brand_uuid`]" class="form-text text-danger">{{ errors[`brand_uuid`][0] }}</small>
                                        </div>
                                        <div v-if="!brand.name" class="col-lg-6">
                                            <label>{{ __('product.brand_section.create_own_brand') }}</label>
                                            <div>
                                                <button @click="createBrand = !createBrand" type="button" class="btn btn-primary">
                                                    <i class="fas fa-plus-square"></i>{{ __('product.brand_section.create_new_brand') }}
                                                </button>
                                                <div class="mt-4" v-if="createBrand">
                                                    <create-user-brand @selectBrand="selectBrand"></create-user-brand>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--        PRODUCTSECTION        -->
                            <div class="timeline-item">
                                <div class="timeline-media bg-light-primary">
                                    <i class="fa fa-clipboard"></i>
                                </div>
                                <div class="timeline-desc timeline-desc-light-primary">
                                    <span class="d-block font-weight-bolder text-primary mb-2">
                                        {{ __('product.product_section.title') }}
                                    </span>
                                    <div class="form-group mb-8 row">
                                        <div class="col-lg-6">
                                            <label>{{ __('general.article_name') }}</label>
                                            <input type="text" class="form-control" :placeholder="__('general.article_name')"
                                                   v-model="productName">
                                            <small v-if="errors[`product_name`]" class="form-text text-danger">{{
                                                    errors[`product_name`][0]
                                                }}</small>
                                            <small v-else class="form-text text-muted">
                                                {{ __('product.product_section.input_article_name') }}
                                            </small>
                                        </div>
                                        <div class="col-lg-6">
                                            <label>{{ __('general.article_description') }}</label>
                                            <textarea type="text" class="form-control"
                                                      v-model="productDescription"
                                                      :placeholder="__('general.article_description')"
                                            ></textarea>
                                            <small v-if="errors[`product_description`]" class="form-text text-danger">{{
                                                    errors[`product_description`][0]
                                                }}</small>
                                            <small v-else class="form-text text-muted">
                                                {{ __('product.product_section.input_article_description') }}
                                            </small>
                                        </div>
                                    </div>

                                    <div class="form-group mb-8 row">
                                        <div class="col-lg-6">
                                            <label>{{ __('general.article_attribute') }}</label>
                                            <article-attributes @setAttributes="setAttributes" />
                                        </div>
                                    </div>
                                    <!--    CATEGORYSECTION    -->
                                    <category-selection @setCategoryId="setCategoryId" />
                                </div>
                            </div>

                            <!--       ARTICLEVARIANTS        -->
                            <div class="timeline-item">
                                <div class="timeline-media bg-light-primary">
                                    <i class="fa fa-list-ul"></i>
                                </div>
                                <div class="timeline-desc timeline-desc-light-primary">
                                    <span
                                        class="d-block font-weight-bolder text-primary mb-2">
                                    {{ __('product.article_variants.title') }}</span
                                    >
                                    <div v-for="(article, index) in articles" class="p-4 mb-10 bg-primary-o-10 rounded">
                                        <div v-if="index !== 0" @click="removeArticleVariant(index)" class="text-right">
                                            <i class="cursor-pointer fa fa-times text-danger"></i>
                                        </div>
                                        <div class="row">
                                            <div v-if="hasEan" class="col-12 form-group">
                                                <CheckEan
                                                    :preset-ean="index === 0 ? articles[0].ean : null"
                                                    @articleNotAllowed="submitNotAllowed = $event"
                                                    @useCustomEan="setArticleEan(article, $event)"
                                                ></CheckEan>
                                                <small v-if="errors[`articles.${index}.ean`]"
                                                       class="form-text text-danger">{{
                                                        errors[`articles.${index}.ean`][0]
                                                    }}</small>
                                            </div>
                                            <div v-else class="col-12 form-group ">
                                                <label>{{ __('product.check_ean.article_ean') }}</label>
                                                <input type="text" class="form-control"
                                                       :placeholder="__('product.article_variants.input_ean_placeholder')"
                                                       disabled>
                                            </div>

                                            <!--      ARTICLE IMAGES     -->
                                            <div class="col-lg-6 form-group">
                                                <label>{{ __('general.image_images') }}</label><br>
                                                <label :for="`uploadImages${index}`"
                                                       class="btn btn-primary mb-0">
                                                <span class="svg-icon svg-icon-md">
                                                    <i class="fas fa-file-image"></i>
                                                </span>
                                                    {{ __('product.article_variants.choose_images') }}
                                                </label>
                                                <input :ref="`uploadImages${index}`" :id="`uploadImages${index}`"
                                                       type="file"
                                                       @change="imagesChanged($event, article)"
                                                       multiple
                                                       class="d-none">
                                                <small v-if="errors[`articles.${index}.images.0`]"
                                                       class="form-text text-danger">{{
                                                        errors[`articles.${index}.images.0`][0]
                                                    }}</small>
                                                <small class="form-text text-muted" v-html="__('product.article_variants.images_quality')"></small>
                                                <div v-if="article.images && article.images.length > 0">
                                                    <div v-for="imageUrl in article.tempImages"
                                                         class="d-inline-block border border-light">
                                                        <img :src="imageUrl" height="64"
                                                             class="mr-2 rounded overflow-hidden"
                                                             :alt="__('general.article_image')">
                                                    </div>
                                                    <div class="ml-4 btn btn-danger"
                                                         @click="resetImages(article, index)">
                                                         <span class="svg-icon svg-icon-md">
                                                         <i class="fas fa-trash"></i>
                                                        </span>
                                                        {{ __('product.article_variants.images_reset') }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 form-group">
                                                <label>
                                                    {{ __('general.producer_number_short') }}
                                                </label>
                                                <input type="text" class="form-control" v-model="article.sku">
                                                <small class="form-text text-muted">
                                                    {{ __('product.article_variants.producer_number_description') }}
                                                </small>
                                            </div>
                                        </div>

                                        <!--    ARTICLE ATTRIBUTES      -->
                                        <div class="row">
                                            <div class="col-4"
                                                 v-for="(attribute, attributeIndex) in selectedAttributes">
                                                <div v-if="article.attributes[attributeIndex]" class="form-group">
                                                    <label>{{ attribute.name }}</label>
                                                    <input class="form-control" :placeholder="attribute.placeholder"
                                                           type="text"
                                                           v-model="article.attributes[attributeIndex].value">
                                                    <small
                                                        v-if="errors[`articles.${index}.attributes.${attributeIndex}.value`]"
                                                        class="form-text text-danger">{{
                                                            errors[`articles.${index}.attributes.${attributeIndex}.value`][0]
                                                        }}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="selectedAttributes.length" class="form-group mb-8 row">
                                        <button class="btn btn-primary ml-4" @click="newArticleVariant" type="button">
                                            <i
                                                class="fas fa-plus-square"></i>
                                            {{ __('product.article_variants.additional_variant') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--        ADD TO STORE        -->
                        <div v-if="!queryEan || articleFound" class="timeline-item">
                            <div class="timeline-media bg-light-primary">
                                <i class="fa fa-building"></i>
                            </div>
                            <div class="timeline-desc timeline-desc-light-primary">
                                <span class="d-block font-weight-bolder text-primary mb-2">
                                    {{ __('product.article.title') }}
                                </span>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>{{ __('general.stores') }}</label>
                                        <VueMultiselect :placeholder="__('product.article.select_stores_placeholder')" multiple
                                                         v-model="selectedStores"
                                                         @remove="removeStoreStocksFromAllArticles($event)"
                                                         track-by="label" label="label"
                                                         :options="storeOptions"></VueMultiselect>
                                        <small class="form-text text-muted">
                                            {{ __('product.article.select_stores_description') }}
                                        </small>
                                    </div>
                                </div>

                                <div v-for="selectedStore in selectedStores" class="p-4 mb-10 bg-primary-o-10 rounded">
                                    <h5 class="mb-4">{{ __('product.article.create_in') }}: {{ selectedStore.label }}</h5>
                                    <VueMultiselect
                                        @select="addStoreStockToArticle($event, selectedStore)"
                                        v-model="selectedStoreArticles[selectedStore.uuid]"
                                        @remove="removeStoreStockFromArticle($event, selectedStore)"
                                        :placeholder="__('product.article.create_in_placeholder')"
                                        multiple
                                        :options="articles"
                                        track-by="label"
                                        :custom-label="(article) => articleLabel(article)"
                                    >
                                    </VueMultiselect>
                                    <small class="form-text text-muted">
                                        {{ __('product.article.create_in_description') }}
                                    </small>

                                    <div v-for="(article, index) in articles">
                                        <div class="form-group ml-8 mt-6" v-if="article.stocks[selectedStore.uuid]">
                                            <h5>{{ article.label }}</h5>
                                            <div class="row mb-3">
                                                <div class="col-6">
                                                    <label>{{ __('product.article.quantity_stock') }}</label>
                                                    <input type="text"
                                                           class="form-control"
                                                           v-model="article.stocks[selectedStore.uuid].quantity"
                                                           placeholder="5">
                                                    <small
                                                        v-if="errors[`articles.${index}.stocks.${selectedStore.uuid}.quantity`]"
                                                        class="form-text text-danger">{{
                                                            errors[`articles.${index}.stocks.${selectedStore.uuid}.quantity`][0]
                                                        }}</small>
                                                    <small
                                                        v-else-if="errors[`stocks.${selectedStore.uuid}.quantity`]"
                                                        class="form-text text-danger">{{
                                                            errors[`stocks.${selectedStore.uuid}.quantity`][0]
                                                        }}</small>
                                                </div>
                                                <div class="col-6">
                                                    <label>{{ __('product.article.price') }}</label>
                                                    <input type="number"
                                                           class="form-control"
                                                           v-model="article.stocks[selectedStore.uuid].price"
                                                           placeholder="99.95">
                                                    <small
                                                        v-if="errors[`articles.${index}.stocks.${selectedStore.uuid}.price`]"
                                                        class="form-text text-danger">{{
                                                            errors[`articles.${index}.stocks.${selectedStore.uuid}.price`][0]
                                                        }}</small>
                                                    <small
                                                        v-else-if="errors[`stocks.${selectedStore.uuid}.price`]"
                                                        class="form-text text-danger">{{
                                                            errors[`stocks.${selectedStore.uuid}.price`][0]
                                                        }}</small>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-6">
                                                    <label>{{ __('product.article.custom_id') }}</label>
                                                    <input type="text"
                                                           class="form-control"
                                                           v-model="article.stocks[selectedStore.uuid].in_store_article_id"
                                                           placeholder="HemdABC-xl3">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ml-14 mb-16">
                <button v-if="stepOneCompleted && !loading" @click="submit" class="btn btn-primary"
                        :class="submitNotAllowed ? 'disabled' : ''" :disabled="submitNotAllowed">
                    {{ __('actions.create') }} <i class="fa fa-arrow-right" aria-hidden="true"></i>
                </button>
                <div v-if="loading" class="d-flex align-items-center mr-4">
                    <div class="ml-2 text-muted"></div>
                    <div class="spinner spinner-primary mr-10"></div>
                </div>
            </div>
        </div>

        <!--    SUCCESS   -->
        <div v-if="success">
            <div v-for="(article, index) in articles" class="card mx-5 mb-8">
                <article-box :article="article" :article-found="articleFound" :product-name="productName"
                             :brand-name="brand.name" :success-ean="successEans[index]" :success="true"></article-box>
            </div>

            <div class="row flex-wrap justify-content-around mt-8">
                <a :href="$route('store.articles.index', [redirectStoreUuid])">
                    <button class="btn btn-primary mx-2 mb-6 mb-lg-0 flex-1" type="button">
                        {{ __('actions.article_overview') }}
                    </button>
                </a>
                <a :href="$route('article.create')">
                    <button class="btn btn-primary mx-2 flex-1" type="button"><i
                        class="fas fa-plus-square"></i>
                        {{ __('actions.create_additional_article') }}
                    </button>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import NewArticleBrand from '@components/Article/NewArticleBrand.vue'
import CreateUserBrand from '@components/Brand/CreateUserBrand.vue'
import ArticleAttributes from '@components/Article/ArticleAttributes.vue'
import CheckEan from '@components/Article/CheckEan.vue'
import VueMultiselect from 'vue-multiselect'
import AcceptEanAgb from '@components/Article/AcceptEanAgb.vue'
import {serialize} from 'object-to-formdata'
import CategorySelection from '@components/Category/CategorySelection.vue'
import ArticleBox from '@components/Article/ArticleBox.vue'
import Toolbar from '@components/Toolbar.vue'
import ToolbarLink from '@components/ToolbarLink.vue'
import HelpButton from '@components/HelpButton.vue'

export default {
    name: 'CreateProduct',
    components: {
        HelpButton,
        ToolbarLink, Toolbar,
        ArticleBox,
        CategorySelection,
        AcceptEanAgb, ArticleAttributes, CreateUserBrand, NewArticleBrand, CheckEan, VueMultiselect,
    },
    props: {
        stores: Array,
        queryEan: String,
    },
    data() {
        return {
            loading: false,
            stepOneCompleted: false,
            //EAN
            hasEan: Boolean,
            agbAccepted: false,
            successEans: [],
            // Brands
            brand: {
                name: '',
                uuid: '',
                slug: '',
            },
            createBrand: false,
            // Product
            productName: '',
            productDescription: '',
            selectedAttributes: [],
            // Articles
            articles: [
                {
                    ean: '',
                    tempImages: [],
                    images: [],
                    attributes: [],
                    stocks: {},
                },
            ],
            articleFound: false,
            selectedStoreArticles: [],
            // Stores
            storeOptions: [],
            selectedStores: [],
            // Category
            categoryId: 0,
            // Errors
            errors: {},
            submitNotAllowed: false,
            success: false,
        }
    },
    computed: {
        redirectStoreUuid() {
            return this.selectedStores.length === 0 ? this.stores[0].id : this.selectedStores[0].uuid
        },
    },
    watch: {
        selectedAttributes: {
            handler: function(val, oldVal) {
                this.articles.forEach((article) => {
                    let values = []
                    article.attributes.forEach((attribute) => {
                        values[attribute.id] = attribute.value
                    })

                    val.forEach((attribute) => {
                        values.forEach((value, index) => {
                            if (index === attribute.id) {
                                attribute.value = value
                            }
                        })
                    })
                    this.$set(article, 'attributes', _.cloneDeep(val))
                })
            },
            deep: true,
        },
    },

    mounted() {
        this.mapStoreLabels()
        if (this.stores.length === 1) {
            this.selectedStores[0] = this.storeOptions[0]
        }
        if (this.queryEan) {
            this.articles[0].ean = this.queryEan
            this.hasEan = true
            this.stepOneCompleted = true
        }
    },

    methods: {
        async submit() {
            this.errors = {}
            this.loading = true
            const formOptions = {
                indices: true,
                nullsAsUndefineds: false,
                booleansAsIntegers: false,
                allowEmptyArrays: true,
                noFilesWithArrayNotation: false,
                dotsForObjectNotation: false,
            }
            try {
                this.articleFound
                    ? await this.submitAddArticleToStore(formOptions, this.articles[0])
                    : await this.submitCreate(formOptions)
                this.success = true
            } catch (error) {
                this.errors = error.response.data.errors
                if (error.response.status === 422) {
                    toastr.error(__('product.toast_submit.error'))
                } else {
                    toastr.error(error.message)
                }
            }
            this.loading = false
        },

        async submitAddArticleToStore(options, article) {
            let formData = serialize(article.stocks, options, null, 'stocks')
            formData.append('ean', article.ean)

            await axios.post(route('article.add-to-store'), formData)
            let successMessage = article.stocks.length > 1
                ? __('product.article.articles_added')
                : __('product.article.article_added')
            toastr.success(successMessage)
            this.successEans.push(article.ean)
        },

        async submitCreate(options) {
            let formData = serialize(this.articles, options, null, 'articles')
            formData.append('product_name', this.productName)
            formData.append('brand_uuid', this.brand.uuid)
            formData.append('product_description', this.productDescription)
            formData.append('category_id', this.categoryId)
            formData.append('has_ean', this.hasEan.toString())

            let response = await axios.post(route('product.create'), formData)
            let successMessage = this.articles.length > 1
                ? __('product.article.articles_created')
                : __('product.article.article_created')
            toastr.success(successMessage)
            this.successEans = response.data
        },
        acceptAgb() {
            this.agbAccepted = true
        },
        mapStoreLabels() {
            this.stores.forEach((item) => {
                this.storeOptions.push(
                    {
                        uuid: item.id,
                        label: item.attributes.name + ' - ' + item.attributes.address.street1,
                    })
            })
        },
        articleLabel(article) {
            let label = this.productName

            Object.values(article.attributes).forEach(function(attribute) {
                if (attribute.hasOwnProperty('value') && attribute.value !== undefined) {
                    label += ' - ' + attribute.name + ' ' + attribute.value
                } else if (attribute.hasOwnProperty('pivot')) {
                    label += ' - ' + attribute.name + ' ' + attribute.pivot.value
                }
            })
            article.label = label

            return label
        },
        newArticleVariant() {
            this.articles.push({
                ean: '',
                name: this.productName,
                tempImages: [],
                images: [],
                attributes: _.cloneDeep(this.selectedAttributes),
                stocks: {},
            })
        },
        removeArticleVariant(index) {
            this.$delete(this.articles, index)
        },
        addStoreStockToArticle(article, store) {
            this.$set(article.stocks, store.uuid,
                {quantity: null, price: null, in_store_article_id: null, label: store.label})
        },
        removeStoreStockFromArticle(article, store) {
            delete article.stocks[store.uuid]
        },
        removeStoreStocksFromAllArticles(store) {
            this.articles.forEach((article) => {
                this.$delete(article.stocks, store.uuid)
            })
            this.$delete(this.selectedStoreArticles, store.uuid)
        },
        selectBrand(brand) {
            this.brand = brand
            this.createBrand = false
        },
        resetBrand() {
            this.brand = {
                name: '',
                uuid: '',
                slug: '',
            }
        },
        resetImages(article, index) {
            this.$refs[`uploadImages${index}`].value = []
            article.tempImages = []
            article.images = []
        },
        imagesChanged(event, article) {
            for (let key in event.target.files) {
                if (!event.target.files.hasOwnProperty(key)) continue
                article.tempImages.unshift(URL.createObjectURL(event.target.files[key]))
                article.images.unshift(event.target.files[key])
            }
        },
        setAttributes(attributes) {
            this.selectedAttributes = attributes
        },
        setArticleEan(article, ean) {
            article.ean = ean
            this.stepOneCompleted = true
        },
        setArticle(article) {
            this.articles[0] = article
            this.articles[0].stocks = {}
            this.productName = article.product.name
            this.articleFound = true
            this.stepOneCompleted = true
        },
        setCategoryId(categoryId) {
            this.categoryId = categoryId
        },
    },
}
</script>

<style lang="scss">
.multiselect__tag-icon {
    &:hover {
        background-color: #dc3545;
    }

    &::after {
        color: white;
    }
}
</style>
